import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThankyouTestimonialsComponent } from './thankyou-testimonials.component';
import { NgxGlideModule } from 'ngx-glide';

@NgModule({
  declarations: [ThankyouTestimonialsComponent],
  imports: [
    CommonModule,
    NgxGlideModule
  ],
  exports: [ThankyouTestimonialsComponent]
})
export class ThankyouTestimonialsModule { }
